module.exports = __webpack_public_path__ + "static/media/vaillant.44db1525.png";